import React from 'react';
import {Link} from "react-router-dom";

const HeaderTopBar = () => {
    return (
        <div className="header-top-bar custom-topbar">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="header-left">
                            
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-12 col-12">
                        <div className="header-right">
                            <div className="address-content">
                            </div>
                            <div className="copyright-left">
                                <ul className="ft-menu link-hover d-flex">
                                    <li><Link style={{cursor:'pointer'}} to="/" className='mr-5'>Enterprise</Link></li>
                                    <li><Link style={{cursor:'pointer'}} to="/community" className='mr-5'>Community</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeaderTopBar;
